module.exports = __webpack_public_path__ + "fonts/Brown-Bold.woff";